module.exports = __webpack_public_path__ + "img/detail-map.573e64d0.png";